import { SectionTitleBar } from './SectionTitleBar';
export default SectionTitleBar;
